module.exports = __webpack_public_path__ + "img/eg-2.c94b2a13.jpg";